const COLLAPSED_OVERLAY_HEIGHT = 50;

export const themes = {
  default: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 100%)',
    },
    thButton:
      'reset-button mt-2 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline',
  },
  gray: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #f7f7f7 100%)',
    },
    thButton:
      'reset-button mt-2 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline',
  },
  deepBlue: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage:
        'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, hsla(216, 100%, 18%, 1) 100%)',
    },
    thButton: 'reset-button mt-2 text-base text-white transition-color underline',
  },
};
